<template>
  <div class="catalog">
    <h1 class="title">Categories</h1>
    <el-skeleton :rows="5" animated :loading="isLoading" style="margin-top:100px" />
    <div class="group-box">
      <!-- <div class="group">
        <p class="group-name-box"><i class="group-icon el-icon-folder" /><span class="group-name">Spring</span></p>
        <div class="posts">
          <a href="#" class="post-title">Spirng是如何启动Spirng是如何启动Spirng是如何启动Spirng是如何启动Spirng是如何启动</a>
          <a href="#" class="post-title">MySQL索引和调优</a>
        </div>
      </div> -->
      <div class="group" :key="group.id" v-for="group in groups">
        <p class="group-name-box" @click="toThisCategory(group)"><i class="group-icon el-icon-folder" /><span class="group-name">{{group.categoryName}}</span></p>
        <div class="posts">
          <a :href="`/blog/${b.id}`" class="post-title" :key="b.id" v-for="b in group.blogs">{{b.title}}</a>
        </div>
      </div>

    </div>
  </div>
</template>

<script lang="ts">
import { useGetRequest, useLog } from '@/hooks'
import { AssertGoodResponse } from '@/util/GlobalUtil'
import { useRouter } from 'vue-router'
import { defineComponent, reactive, toRefs } from 'vue'
import { BlogConditionStrategies } from '@/interfaces'

/* eslint-disable */
export default defineComponent({
  setup() {
    const l = useLog()
    const router = useRouter()
    const state = reactive({
      isLoading: true,
      groups: [],
    })
    // 调接口,获取所有类型的所有博客
    useGetRequest('/api/blog/groups_by_category').then((res) => {
      AssertGoodResponse(res)
      state.groups = res.data.data
      state.isLoading = false
    })

    // 跳转到conditon页面, 查看当前类型下的所有博客
    const toThisCategory = (group: any) => {
      router.push({
        name: 'ConditionBlogs',
        query: {
          conditionStrategy: BlogConditionStrategies.BY_CATEGORY,
          value: group.id,
        }
      })
    }

    return {
      ...toRefs(state),
      toThisCategory,
    }
  },
})
</script>

<style lang="scss" scoped>
.catalog {
  .group-box {
    margin-top: 30px;
    overflow: hidden;
    column-count: 2;
    column-gap: 0;
    column-width: 510px;

    .group {
      break-inside: avoid;
      padding: 50px;
      // border: 1px solid red;

      .group-name-box {
        cursor: pointer;
        transition: color 0.5s;
        .group-icon {
          color: $theme-color;
          font-size: 1.2rem;
        }
        .group-name {
          font-size: 1.17rem;
          font-weight: bold;
          margin-left: 10px;
        }
        &:hover {
          color: $theme-color;
        }
      }

      .posts {
        padding-top: 10px;
        padding-left: 30px;

        a.post-title {
          display: block;
          text-decoration: none;
          padding: 5px 0;
          color: black;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          cursor: pointer;
          transition: color 0.3s;
          transition: transform 0.5s;

          &:hover {
            color: $theme-color;
            transform: translateX(10px);
          }
        }
      }
    }
  }
}
</style>